import { render, staticRenderFns } from "./CommentHandler.vue?vue&type=template&id=6171e6c7&scoped=true"
import script from "./CommentHandler.vue?vue&type=script&lang=js"
export * from "./CommentHandler.vue?vue&type=script&lang=js"
import style0 from "./CommentHandler.vue?vue&type=style&index=0&id=6171e6c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6171e6c7",
  null
  
)

export default component.exports